import type { TypedComponentRendering } from '@core/jss-models';
import { getFieldValue } from '@core/jss-utils';

import type {
  OrderContent,
  ScOrderFields,
} from './order-fulfillment-container.model';

export function scRenderingContentMapper(
  rendering: TypedComponentRendering<ScOrderFields>
): OrderContent {
  return {
    cardContent: rendering.fields.CardContent,
    cardTitle: getFieldValue(rendering, 'CardTitle', ''),
    continueAsNewCustomerButtonText: getFieldValue(
      rendering,
      'ContinueAsNewCustomerButtonText',
      ''
    ),
    redirectToMijnButton: rendering.fields.RedirectToMijnButton,
    termsAndConditionsV2: getFieldValue(
      rendering,
      'TermsAndConditionsV2',
      false
    ),
    actionInformationMailFormGroupLabel: getFieldValue(
      rendering,
      'ActionInformationMailFormGroupLabel',
      ''
    ),
    termsAndConditionsFormGroupLabel: getFieldValue(
      rendering,
      'TermsAndConditionsFormGroupLabel',
      ''
    ),
    enableAutomaticEmailOptIn: getFieldValue(
      rendering,
      'EnableAutomaticEmailOptIn',
      false
    ),
    enableNewOfferCardTitles: getFieldValue(
      rendering,
      'EnableNewOfferCardTitles',
      false
    ),
    enableBusinessFields: getFieldValue(
      rendering,
      'EnableBusinessFields',
      false
    ),
    enablePersonalFields: getFieldValue(
      rendering,
      'EnablePersonalFields',
      false
    ),
    enableBusinessCheckbox: getFieldValue(
      rendering,
      'EnableBusinessCheckbox',
      false
    ),
    enableActionMailCheckbox: getFieldValue(
      rendering,
      'EnableActionMailCheckbox',
      false
    ),
    enableInformationMailCheckbox: getFieldValue(
      rendering,
      'EnableInformationMailCheckbox',
      false
    ),
    enableMoveDateInThePast: getFieldValue(
      rendering,
      'EnableMoveDateInThePast',
      false
    ),
    startDateOptionControlEnabled: getFieldValue(
      rendering,
      'StartDateOptionControlEnabled',
      false
    ),
    labelsShownAboveFields: getFieldValue(
      rendering,
      'LabelsShownAboveFields',
      false
    ),
    enableCrossSellStep: getFieldValue(rendering, 'EnableCrossSellStep', false),
    splitIbanText: getFieldValue(rendering, 'splitIbanText', false),
    salutationOptions: rendering.fields.salutationOptions,
    residenceOrWorkplaceOptions: rendering.fields.residenceOrWorkplaceOptions,
    exclusivelyCorporateUsageOptions:
      rendering.fields.exclusivelyCorporateUsageOptions,
    showChangeSupplyAddressLink: getFieldValue(
      rendering,
      'ShowChangeSupplyAddressLink',
      false
    ),
    changeSupplyAddressLinkText: getFieldValue(
      rendering,
      'ChangeSupplyAddressLinkText',
      ''
    ),
    changeSupplyAddressModalTitle: getFieldValue(
      rendering,
      'ChangeSupplyAddressModalTitle',
      ''
    ),
    changeSupplyAddressModalBody: rendering.fields.changeSupplyAddressModalBody,
    changeSupplyAddressModalPrimaryButtonText: getFieldValue(
      rendering,
      'ChangeSupplyAddressModalPrimaryButtonText',
      ''
    ),
    automaticEmailOptInText: rendering.fields.AutomaticEmailOptInText,
    commercialSummary: rendering.fields.commercialSummary,
    commercialTooltip: getFieldValue(rendering, 'CommercialTooltip', ''),
    confirmationSummaryBefore: rendering.fields.confirmationSummaryBefore,
    confirmationSummaryAfter: rendering.fields.confirmationSummaryAfter,
    confirmationSummaryTooltip: getFieldValue(
      rendering,
      'ConfirmationSummaryTooltip',
      ''
    ),
    consentsTextBefore: rendering.fields.ConsentsTextBefore,
    consentsTextLink: getFieldValue(rendering, 'ConsentsTextLink', ''),
    consentsTextAfter: rendering.fields.ConsentsTextAfter,
    consentsMessageTitle: getFieldValue(rendering, 'ConsentsMessageTitle', ''),
    consentsMessageBody: getFieldValue(rendering, 'ConsentsMessageBody', ''),
    consentsMessageButton: getFieldValue(
      rendering,
      'ConsentsMessageButton',
      ''
    ),
    residentialFunctionModalTitle: getFieldValue(
      rendering,
      'ResidentialFunctionModalTitle',
      ''
    ),
    residentialFunctionModalBody: rendering.fields.residentialFunctionModalBody,
    residentialFunctionModalPrimaryButtonText: getFieldValue(
      rendering,
      'ResidentialFunctionModalPrimaryButtonText',
      ''
    ),
    residentialFunctionModalSecondaryButtonText: getFieldValue(
      rendering,
      'ResidentialFunctionModalSecondaryButtonText',
      ''
    ),
    personalCardTitle: rendering.fields.PersonalCardTitle,
    personalCardSubTitle: getFieldValue(rendering, 'PersonalCardSubTitle', ''),
    personalCardSubmitButton: getFieldValue(
      rendering,
      'PersonalCardSubmitButton',
      ''
    ),
    businessFieldsTitle: getFieldValue(rendering, 'BusinessFieldsTitle', ''),
    companyNameLabel: getFieldValue(rendering, 'CompanyNameLabel', ''),
    companyNamePlaceholder: getFieldValue(
      rendering,
      'CompanyNamePlaceholder',
      ''
    ),
    companyNameRequiredError: getFieldValue(
      rendering,
      'CompanyNameRequiredError',
      ''
    ),
    kvkNumberLabel: getFieldValue(rendering, 'KvkNumberLabel', ''),
    kvkNumberPlaceholder: getFieldValue(rendering, 'KvkNumberPlaceholder', ''),
    kvkNumberRequiredError: getFieldValue(
      rendering,
      'KvkNumberRequiredError',
      ''
    ),
    salutationLabel: getFieldValue(rendering, 'SalutationLabel', ''),
    genderRequiredError: getFieldValue(rendering, 'GenderRequiredError', ''),
    initialsLabel: getFieldValue(rendering, 'InitialsLabel', ''),
    initialsPlaceholder: getFieldValue(rendering, 'InitialsPlaceholder', ''),
    initialsRequiredError: getFieldValue(
      rendering,
      'InitialsRequiredError',
      ''
    ),
    insertionLabel: getFieldValue(rendering, 'InsertionLabel', ''),
    insertionPlaceholder: getFieldValue(rendering, 'InsertionPlaceholder', ''),
    surnameLabel: getFieldValue(rendering, 'SurnameLabel', ''),
    surnamePlaceholder: getFieldValue(rendering, 'SurnamePlaceholder', ''),
    surnameRequiredError: getFieldValue(rendering, 'SurnameRequiredError', ''),
    birthdateLabel: getFieldValue(rendering, 'BirthdateLabel', ''),
    birthdatePlaceholder: getFieldValue(rendering, 'BirthdatePlaceholder', ''),
    birthdateRequiredError: getFieldValue(
      rendering,
      'BirthdateRequiredError',
      ''
    ),
    businessClientLabel: getFieldValue(rendering, 'BusinessClientLabel', ''),
    businessClientTooltip: getFieldValue(
      rendering,
      'BusinessClientTooltip',
      ''
    ),
    businessClientMessageTitle: getFieldValue(
      rendering,
      'BusinessClientMessageTitle',
      ''
    ),
    businessClientMessageBody: rendering.fields.BusinessClientMessageBody,
    contactDetailsLabel: getFieldValue(rendering, 'ContactDetailsLabel', ''),
    emailDisclosure: getFieldValue(rendering, 'EmailDisclosure', ''),
    emailLabel: getFieldValue(rendering, 'EmailLabel', ''),
    emailPlaceholder: getFieldValue(rendering, 'EmailPlaceholder', ''),
    emailTooltip: getFieldValue(rendering, 'EmailTooltip', ''),
    emailRequiredError: getFieldValue(rendering, 'EmailRequiredError', ''),
    emailCheckLabel: getFieldValue(rendering, 'EmailCheckLabel', ''),
    emailCheckPlaceholder: getFieldValue(
      rendering,
      'EmailCheckPlaceholder',
      ''
    ),
    phoneLabel: getFieldValue(rendering, 'PhoneLabel', ''),
    phonePlaceholder: getFieldValue(rendering, 'PhonePlaceholder', ''),
    phoneTooltip: getFieldValue(rendering, 'PhoneTooltip', ''),
    phoneRequiredError: getFieldValue(rendering, 'PhoneRequiredError', ''),
    emailValidationError: getFieldValue(rendering, 'EmailValidationError', ''),
    addressCardTitle: rendering.fields.AddressCardTitle,
    addressCardSubtitle: getFieldValue(rendering, 'AddressCardSubtitle', ''),
    addressCardSubmitButton: getFieldValue(
      rendering,
      'AddressCardSubmitButton',
      ''
    ),
    addressCardSubmitButtonWithCrossSell: getFieldValue(
      rendering,
      'AddressCardSubmitButtonWithCrossSell',
      ''
    ),
    supplyAddressTitle: getFieldValue(rendering, 'SupplyAddressTitle', ''),
    correspondenceAddressLabel: getFieldValue(
      rendering,
      'CorrespondenceAddressLabel',
      ''
    ),
    correspondenceAddressTitle: getFieldValue(
      rendering,
      'CorrespondenceAddressTitle',
      ''
    ),
    careOfFullNameLabel: getFieldValue(rendering, 'CareOfFullNameLabel', ''),
    careOfFullNamePlaceholder: getFieldValue(
      rendering,
      'CareOfFullNamePlaceholder',
      ''
    ),
    postalCodeLabel: getFieldValue(rendering, 'PostalCodeLabel', ''),
    postalCodePlaceholder: getFieldValue(
      rendering,
      'PostalCodePlaceholder',
      ''
    ),
    houseNumberLabel: getFieldValue(rendering, 'HouseNumberLabel', ''),
    houseNumberPlaceholder: getFieldValue(
      rendering,
      'HouseNumberPlaceholder',
      ''
    ),
    residenceOrWorkplaceText: getFieldValue(
      rendering,
      'ResidenceOrWorkplaceText',
      ''
    ),
    residenceOrWorkplaceLabel: getFieldValue(
      rendering,
      'ResidenceOrWorkplaceLabel',
      ''
    ),
    residenceOrWorkplaceTooltip: getFieldValue(
      rendering,
      'ResidenceOrWorkplaceTooltip',
      ''
    ),
    residenceOrWorkplaceRequiredError: getFieldValue(
      rendering,
      'ResidenceOrWorkplaceRequiredError',
      ''
    ),
    inswitchText: getFieldValue(rendering, 'InswitchText', ''),
    inswitchLabel: getFieldValue(rendering, 'InswitchLabel', ''),
    transitionDateLabel: getFieldValue(rendering, 'TransitionDateLabel', ''),
    transitionDatePlaceholder: getFieldValue(
      rendering,
      'TransitionDatePlaceholder',
      ''
    ),
    transitionDateRequiredError: getFieldValue(
      rendering,
      'TransitionDateRequiredError',
      ''
    ),
    inhouseTermLabel: getFieldValue(rendering, 'InhouseTermLabel', ''),
    inhouseTermTooltip: getFieldValue(rendering, 'InhouseTermTooltip', ''),
    moveDateInPastInfoMessage: rendering.fields.MoveDateInPastInfoMessage,
    noStartDateOptionChosenErrorMessage: getFieldValue(
      rendering,
      'NoStartDateOptionChosenErrorMessage',
      ''
    ),
    earliestPossibleStartDateRadioButtonLabel: getFieldValue(
      rendering,
      'EarliestPossibleStartDateRadioButtonLabel',
      ''
    ),
    customStartDateRadioButtonLabel: getFieldValue(
      rendering,
      'CustomStartDateRadioButtonLabel',
      ''
    ),
    helpText: rendering.fields.HelpText,
    situationOtherSupplierInfoMessageButtonLink:
      rendering.fields.SituationOtherSupplierInfoMessageButtonLink,
    situationNoSupplierInswitchText: getFieldValue(
      rendering,
      'SituationNoSupplierInswitchText',
      ''
    ),
    dropdownLabel: getFieldValue(rendering, 'DropdownLabel', ''),
    dropdownPlaceholder: getFieldValue(rendering, 'DropdownPlaceholder', ''),
    dropdownSelectionRequiredError: getFieldValue(
      rendering,
      'DropdownSelectionRequiredError',
      ''
    ),
    situationNoSupplierLabel: getFieldValue(
      rendering,
      'SituationNoSupplierLabel',
      ''
    ),
    situationNoSupplierDatePickerTooltip: getFieldValue(
      rendering,
      'SituationNoSupplierDatePickerTooltip',
      ''
    ),
    situationOtherSupplierLabel: getFieldValue(
      rendering,
      'SituationOtherSupplierLabel',
      ''
    ),
    situationOtherSupplierInfoMessage:
      rendering.fields.SituationOtherSupplierInfoMessage,
    situationOtherSupplierDatePickerTooltip: getFieldValue(
      rendering,
      'SituationOtherSupplierDatePickerTooltip',
      ''
    ),
    situationRetentionLabel: getFieldValue(
      rendering,
      'SituationRetentionLabel',
      ''
    ),
    situationRetentionInfoMessage:
      rendering.fields.SituationRetentionInfoMessage,
    situationRetentionInfoMessageButtonLink:
      rendering.fields.SituationRetentionInfoMessageButtonLink,
    situationMoveOtherSupplierLabel: getFieldValue(
      rendering,
      'SituationMoveOtherSupplierLabel',
      ''
    ),
    situationMoveOtherSupplierInfoMessage:
      rendering.fields.SituationMoveOtherSupplierInfoMessage,
    situationMoveOtherSupplierDatePickerTooltip: getFieldValue(
      rendering,
      'SituationMoveOtherSupplierDatePickerTooltip',
      ''
    ),
    situationMoveLabel: getFieldValue(rendering, 'SituationMoveLabel', ''),
    situationMoveInfoMessage: rendering.fields.SituationMoveInfoMessage,
    situationMoveInfoMessageButtonLink:
      rendering.fields.SituationMoveInfoMessageButtonLink,
    situationExtraAddressLabel: getFieldValue(
      rendering,
      'SituationExtraAddressLabel',
      ''
    ),
    situationExtraAddressInfoMessage:
      rendering.fields.SituationExtraAddressInfoMessage,
    situationSummaryLabel: getFieldValue(
      rendering,
      'SituationSummaryLabel',
      ''
    ),
    situationMoveOtherSupplierDatePickerInfoMessage: getFieldValue(
      rendering,
      'SituationMoveOtherSupplierDatePickerInfoMessage',
      ''
    ),
    situationOtherSupplierDatePickerInfoMessage: getFieldValue(
      rendering,
      'SituationOtherSupplierDatePickerInfoMessage',
      ''
    ),
    situationMoveOtherSupplierInswitchText: getFieldValue(
      rendering,
      'SituationMoveOtherSupplierInswitchText',
      ''
    ),
    situationOtherSupplierInswitchText: getFieldValue(
      rendering,
      'SituationOtherSupplierInswitchText',
      ''
    ),
    paymentCardTitle: rendering.fields.PaymentCardTitle,
    paymentCardSubtitle: getFieldValue(rendering, 'PaymentCardSubtitle', ''),
    paymentCardSubmitButton: getFieldValue(
      rendering,
      'PaymentCardSubmitButton',
      ''
    ),
    ibanText: rendering.fields.IbanText,
    ibanLabel: getFieldValue(rendering, 'IbanLabel', ''),
    ibanPlaceholder: getFieldValue(rendering, 'IbanPlaceholder', ''),
    ibanRequiredError: getFieldValue(rendering, 'IbanRequiredError', ''),
    ibanBlacklistedError: rendering.fields.IbanBlacklistedError,
    ibanTextMobile: { value: getFieldValue(rendering, 'ibanTextMobile', '') },
    ibanTextDesktop: { value: getFieldValue(rendering, 'ibanTextDesktop', '') },
    checkCardTitle: getFieldValue(rendering, 'CheckCardTitle', ''),
    checkCardSubtitle: getFieldValue(rendering, 'CheckCardSubtitle', ''),
    checkCardSubmitButton: getFieldValue(
      rendering,
      'CheckCardSubmitButton',
      ''
    ),
    acceptConditionsTextBefore: getFieldValue(
      rendering,
      'AcceptConditionsTextBefore',
      ''
    ),
    acceptConditionsTextAfter: getFieldValue(
      rendering,
      'AcceptConditionsTextAfter',
      ''
    ),
    acceptConditionsTextDynamicContract: getFieldValue(
      rendering,
      'AcceptConditionsTextDynamicContract',
      ''
    ),
    generalTermsAndConditions: getFieldValue(
      rendering,
      'GeneralTermsAndConditions',
      ''
    ),
    qualityCriteria: getFieldValue(rendering, 'QualityCriteria', ''),
    productConditions: getFieldValue(rendering, 'ProductConditions', ''),
    campaignConditions: getFieldValue(rendering, 'CampaignConditions', ''),
    acceptConditionsRequiredError: getFieldValue(
      rendering,
      'AcceptConditionsRequiredError',
      ''
    ),
    acceptConditionsLabel: getFieldValue(
      rendering,
      'AcceptConditionsLabel',
      ''
    ),
    actionMail: getFieldValue(rendering, 'ActionMail', ''),
    informationMail: getFieldValue(rendering, 'InformationMail', ''),
    emailConsentLabel: getFieldValue(rendering, 'EmailConsentLabel', ''),
    crossSellDesktopOnly: getFieldValue(
      rendering,
      'CrossSellDesktopOnly',
      false
    ),
    crossSellCardTitle: getFieldValue(rendering, 'CrossSellCardTitle', ''),
    crossSellCardSubtitle: getFieldValue(
      rendering,
      'CrossSellCardSubtitle',
      ''
    ),
    crossSellCardSubmitButton: getFieldValue(
      rendering,
      'CrossSellCardSubmitButton',
      ''
    ),
    crossSellProduct: rendering.fields.CrossSellProduct,
    crossSellInfoModalLink: getFieldValue(
      rendering,
      'CrossSellInfoModalLink',
      ''
    ),
    crossSellNoProductSelectedTitle: getFieldValue(
      rendering,
      'CrossSellNoProductSelectedTitle',
      ''
    ),
    crossSellNoProductSelectedSubtitle: getFieldValue(
      rendering,
      'CrossSellNoProductSelectedSubtitle',
      ''
    ),
    crossSellMonthlyShort: getFieldValue(
      rendering,
      'CrossSellMonthlyShort',
      ''
    ),
    crossSellMonthlyLong: getFieldValue(rendering, 'CrossSellMonthlyLong', ''),
    crossSellAddLabel: getFieldValue(rendering, 'CrossSellAddLabel', ''),
    crossSellAddedLabel: getFieldValue(rendering, 'CrossSellAddedLabel', ''),
    crossSellRejectLabel: getFieldValue(rendering, 'CrossSellRejectLabel', ''),
    crossSellInputRequiredError: getFieldValue(
      rendering,
      'CrossSellInputRequiredError',
      ''
    ),
    crossSellUseNewDesign: getFieldValue(
      rendering,
      'CrossSellUseNewDesign',
      false
    ),
    crossSellCardContentTitle: getFieldValue(
      rendering,
      'CrossSellCardContentTitle',
      ''
    ),
    crossSellNoOptionLabel: getFieldValue(
      rendering,
      'CrossSellNoOptionLabel',
      ''
    ),
    emailConsentsModalTitle: getFieldValue(
      rendering,
      'EmailConsentsModalTitle',
      ''
    ),
    emailConsentsModalBody: rendering.fields.EmailConsentsModalBody,
    emailConsentsModalEnergyAdviceCheckbox: getFieldValue(
      rendering,
      'EmailConsentsModalEnergyAdviceCheckbox',
      ''
    ),
    emailConsentsModalSustainabilityCheckbox: getFieldValue(
      rendering,
      'EmailConsentsModalSustainabilityCheckbox',
      ''
    ),
    emailConsentsModalPrimaryButton: getFieldValue(
      rendering,
      'EmailConsentsModalPrimaryButton',
      ''
    ),
    emailConsentsModalSecondaryButton: getFieldValue(
      rendering,
      'EmailConsentsModalSecondaryButton',
      ''
    ),
  };
}
